export default "__VITE_ASSET__1fqMnxg1JZ4IzM67Jng1vA__"